/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { type IGatsbyImageData, getSrc, getSrcSet } from "gatsby-plugin-image";
import type { Image } from "./modules/types";

export const CMS_Module_Pre_Hooks = [
	{
		type: "content_module_video_chapters",
		callback: (data: any, _lang: string) => {
			return {
				...data,
				chapters: data.chapters.map((dc) => {
					return {
						...getTranslationsForLanguage(dc.chapters_id, _lang),
					};
				}),
			};
		},
	},
	{
		type: "content_module_image_with_text",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
		callback: (data: any, _lang: string) => {
			let img = null;
			if (data.src || typeof data.image === "string") return data;
			if (!(typeof data.image === "string")) {
				img = data.image ? parseGatsbyImage(data.image)?.src : null;
			}
			return {
				...data,
				image: img,
			};
		},
	},

	{
		type: "content_module_video_on_demand",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
		callback: (data: any, _lang: string) => {
			if (!data.poster) return data;
			return {
				...data,
				poster: data.poster ? parseGatsbyImage(data.poster) : null,
			};
		},
	},

	{
		type: "content_module_fullscreen_slogan",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
		callback: (data: any, lang: string) => {
			return {
				...data,
				hero_menu_cards: (data.hero_menu_cards || [])
					.slice()
					.sort((a: any, b: any) => (a.sort ?? 0) - (b.sort ?? 0))
					.map((card: any) => {
						const { translations, ...rest } = card;
						const t =
							translations?.find(
								(tr: any) => tr.languages_code?.code?.split("-")[0] === lang?.split("-")[0],
							) || translations?.[0];
						const key = lang?.split("-")[0] || "en";
						const rawUrl = t?.url || rest.url;
						const isInternal =
							typeof rawUrl === "string" &&
							/^\/(?!\/)/.test(rawUrl) &&
							!new RegExp(`^/${key}(/|$|[?#])`).test(rawUrl);
						const url = isInternal
							? `/${key}${rawUrl === "/" ? "" : rawUrl}`
							: rawUrl;
						return { ...rest, url, title: t?.title, description: t?.description };
					}),
				key_visual: data.key_visual ? parseGatsbyImage(data.key_visual) : null,
				key_visual_video: data.key_visual_video
					? {
							...data.key_visual_video,
							localPath: `/assets/videos/${data.key_visual_video.filename_download || `${data.key_visual_video.id}.mp4`}`,
						}
					: null,
			};
		},
	},
	/* {
		type: "content_module_live_stream",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
		callback: (data: any, _lang: string) =>
			preHookLivestreamModule(data, _lang),
	}, */

	{
		type: "content_module_livestream_teaser",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
		callback: (data: any, _lang: string) => {

			return {
				...data,
				livestream_content_modules: data?.livestream_content_modules
					?.filter((lcm: any) => lcm?.content_module_live_stream_id)
					?.map((lcm: any) => {
						return {
							id: lcm.id,
							...preHookLivestreamModule(
								getTranslationsForLanguage(
									lcm.content_module_live_stream_id,
									_lang,
								),
								_lang,
							),
						};
					}) || [],
			};
		},
	},

	{
		type: "content_module_accordion",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => {
			return {
				...data,
				groups:
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					data?.groups?.map(
						(group: {
							content_module_accordion_group_id: { entries: any[] };
						}) => ({
							...getTranslationsForLanguage(
								group?.content_module_accordion_group_id,
								lang,
							),
							entries:
								group?.content_module_accordion_group_id?.entries?.map(
									// eslint-disable-next-line @typescript-eslint/no-explicit-any
									(entry: { content_module_accordion_entry_id: any }) =>
										getTranslationsForLanguage(
											entry?.content_module_accordion_entry_id,
											lang,
										),
								) || [],
						}),
					) || [],
				entries:
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					data?.entries?.map(
						(entry: { content_module_accordion_entry_id: any }) =>
							getTranslationsForLanguage(
								entry?.content_module_accordion_entry_id,
								lang,
							),
					) || [],
			};
		},
	},
	{
		type: "content_module_virtual_tour_selection",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => {
			return {
				...data,
				...getTranslationsForLanguage(data, lang),
				tours:
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					data?.tours
						?.filter(({ tour_id }) => tour_id !== null)
						.map(({ tour_id }: any) => {
							const ret = {
								...tour_id,
								...getTranslationsForLanguage(tour_id, lang),
							};
							delete ret.translations;
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							const scene = ret.steps?.[0]?.scene?.id || null;
							delete ret.steps;

							return {
								...ret,
								image: ret.image ? parseGatsbyImage(ret.image) : null,
								scene,
							};
						}) || [],
			};
		},
	},
	{
		type: "content_module_video_slider",
		callback: (data: any, lang: string) => ({
			...data,
			videos: data?.videos.map((v) => {
				const video = v.content_module_video_slider_video_id;
				return {
					...getTranslationsForLanguage(video, lang),
					poster: video.poster ? parseGatsbyImage(video.poster) : null,
				};
			}),
		}),
	},
	{
		type: "content_module_video_reel",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => ({
			...data,
			videos: (data.videos || [])
				.slice()
				.sort((a: any, b: any) => (a.sort ?? 0) - (b.sort ?? 0))
				.map((video: any) => {
					const { translations, ...rest } = video;
					const t =
						translations?.find(
							(tr: any) =>
								tr.languages_code?.code?.split("-")[0] === lang?.split("-")[0],
						) || translations?.[0];
					const english = translations?.find(
						(tr: any) => tr.languages_code?.code?.split("-")[0] === "en",
					);
					const hasVideo = (tr: any) => !!(tr?.video_url || tr?.video_file?.id);
					const hasOwnVideo = hasVideo(t);
					const isEnglish = (lang?.split("-")[0] ?? "en") === "en";
					// language video, then the English one, then the video set on the item itself
					const source = hasOwnVideo ? t : hasVideo(english) ? english : null;
					const own = source
						? {
								source: source.video_file?.id ? "asset" : "url",
								video_url: source.video_url,
								video_file: source.video_file,
							}
						: {};
					return {
						...rest,
						...own,
						english_only: !isEnglish && !hasOwnVideo,
						title: t?.title,
						tracking_title: video.internal_title || english?.title || t?.title,
					};
				}),
		}),
	},
	{
		type: "content_module_social_media_teaser_video",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => {
			const { translations, ...rest } = data;
			const t =
				translations?.find(
					(tr: any) =>
						tr.languages_code?.code?.split("-")[0] === lang?.split("-")[0],
				) || translations?.[0];
			if (!t) return rest;
			return {
				...rest,
				headline: t.headline,
				video_title: t.video_title,
				title: t.title,
				description: t.description,
				button_label: t.button_label,
				video_url: t.video_url || rest.video_url,
				button_url: t.button_url || rest.button_url,
			};
		},
	},
	{
		type: "content_module_teaser_row",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const pick = (translations: any[] | undefined) =>
				translations?.find(
					(tr) =>
						tr.languages_code?.code?.split("-")[0] === lang?.split("-")[0],
				) || translations?.[0];
			const { translations, teasers, tags, ...rest } = data;
			// The module's own translation is usually merged before the hook runs.
			const t = pick(translations);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const flattenTag = (tag: any) => ({
				id: tag.id,
				sort: tag.sort,
				name: tag.translations ? pick(tag.translations)?.name : tag.name,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const bySort = (a: any, b: any) => (a.sort ?? 0) - (b.sort ?? 0);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const cleanTags = (list: any[] | undefined) =>
				(list || [])
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					.map((entry: any) => ("tags_id" in entry ? entry.tags_id : entry))
					.filter(Boolean)
					.map(flattenTag)
					.sort(bySort)
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					.filter((tag: any) => tag.name)
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					.map(({ sort, ...tag }: any) => tag);
			return {
				...rest,
				...(t
					? {
							title: t.title,
							description: t.description,
							filter_label: t.filter_label,
							highlight_toggle_label: t.highlight_toggle_label,
							highlight_label: t.highlight_label,
						}
					: {}),
				tags: cleanTags(tags),
				teasers: (teasers || [])
					.slice()
					.sort(bySort)
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					.map(({ translations: tt, tags: teaserTags, ...teaser }: any) => {
						const tr = pick(tt);
						const english = tt?.find(
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							(entry: any) => entry.languages_code?.code?.split("-")[0] === "en",
						);
						return {
							...teaser,
							tracking_title: teaser.internal_title || english?.title || tr?.title,
							...(tr
								? {
										title: tr.title,
										description: tr.description,
										link_label: tr.link_label,
										link_url: tr.link_url || teaser.link_url,
									}
								: {}),
							tags: cleanTags(teaserTags),
						};
					}),
			};
		},
	},
	{
		type: "content_module_onsite",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => {
			if (!data.translations) return data;
			const { translations, ...rest } = data;
			const t =
				translations?.find(
					(tr: any) =>
						tr.languages_code?.code?.split("-")[0] === lang?.split("-")[0],
				) || translations?.[0];
			return {
				...rest,
				title: t?.title,
				description: t?.description,
				label_onsite: t?.label_onsite,
				label_remote: t?.label_remote,
			};
		},
	},
	{
		type: "content_module_survey",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => {
			return preHookSurvey(data, lang);
		},
	},
	{
		type: "content_module_event_teaser",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => ({
			...data,
			survey: data.survey ? preHookSurvey(data.survey, lang) : null,
		}),
	},
	{
		type: "content_module_survey_with_event_teaser",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => ({
			...data,
			survey: preHookSurvey(data.survey, lang),
		}),
	},
	{
		type: "content_module_video_gallery",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		callback: (data: any, lang: string) => preHookVideoGallery(data, lang),
	},

	{
		type: "content_module_story",
		callback: (data: any) => ({
			...data,
			stories: data?.stories.map((v) => {
				return v.directus_files_id
					? parseGatsbyImage(v.directus_files_id)
					: null;
			}),
		}),
	},
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const preHookSurvey = (data: any, lang: string) => {
	const questions_parsed =
		data?.questions?.map(
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			({
				content_module_survey_questions_id: {
					translations,
					options,
					...question
				},
			}) => {
				return {
					...question,
					...getTranslationsForLanguage({ ...question, translations }, lang),
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore

					options: options.map(({ translations, ...option }) => {
						const trans = getTranslationsForLanguage(
							{ ...option, translations },
							lang,
						);
						return {
							...option,
							...trans,
							image: trans.image ? parseGatsbyImage(trans.image) : null,
						};
					}),
				};
			},
		) || [];
	return {
		...data,
		questions_parsed,
		/* ?.map((content_module_survey_questions_id) => {
			return content_module_survey_questions_id;
		}), */
	};
	// biome-ignore lint/correctness/noUnreachable: early return deliberately disables the code below
	return {
		...data,

		questions:
			data?.questions?.map(
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				({
					content_module_survey_questions_id: {
						translations,
						options,
						...question
					},
				}) => {
					return {
						...question,
						...getTranslationsForLanguage({ ...question, translations }, lang),
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore

						options: options.map(({ translations, ...option }) => {
							const trans = getTranslationsForLanguage(
								{ ...option, translations },
								lang,
							);
							return {
								...option,
								...trans,
								image: trans.image ? parseGatsbyImage(trans.image) : null,
							};
						}),
					};
				},
			) || [],
	};
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const preHookLivestreamModule = (data: any, _lang: string) => {
	return {
		...data,
		/* session_display: data?.session_display?.map((sd) => ({
			...getTranslationsForLanguage(sd.content_module_event_display_id, lang),
		})),
		livestream_channel: {
			...data.livestream_channel,
			categories:
				data.livestream_channel?.categories?.map((category) => ({
					...category.categories_id,
				})) || [],
			category_slugs:
				data.livestream_channel?.categories?.map(
					(category) => category.categories_id?.slug,
				) || [],
		},
		card_image: data.card_image ? parseGatsbyImage(data.card_image) : null,
		offset_start: data.offset_start || 0,
		offset_end: data.offset_end || 0,
		categories: data?.agenda_categories?.map((c) => c.categories_id?.slug), */
	};
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getTranslationsForLanguage(
	pageTranslations: any,
	langCode: string,
) {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	//@ts-ignore
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	return pageTranslations;
	// biome-ignore lint/correctness/noUnreachable: early return deliberately disables the code below
	const { translations: trans, ...rest } = pageTranslations;

	if (!trans) return pageTranslations;
	const translationForCurrentLanguage = trans?.find(
		(t: { languages_code: { code: string } }) =>
			t.languages_code.code === langCode ||
			t.languages_code.code.split("-")?.[0] === langCode,
	);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { languages_code, ...translations } =
		translationForCurrentLanguage || {};
	return { ...rest, ...translations };
}

const preHookVideoGallery = (data: any, lang: string) => {
	return {
		...data,
		videos: data.videos.map((d) => {
			const video = d.content_module_video_gallery_video_id;
			return {
				...getTranslationsForLanguage(video, lang),
				poster: video.poster ? parseGatsbyImage(video.poster) : null,
				//getTranslationsForLanguage
			};
		}),
	};
};

export const parseGatsbyImage = (
	imgData: Omit<Image, "src" | "srcSet"> & { imageFile: IGatsbyImageData } = {},
): Image => {
	if (!imgData?.imageFile) return null;
	const { id, title, width, height, filesize, imageFile } = imgData;
	return {
		id,
		title,
		width,
		height,
		filesize,
		src: getSrc(imageFile) || "",
		srcSet: getSrcSet(imageFile),
	};
};
